import { gql } from '@apollo/client';
import { graphql } from '@xolv-mybrightlink/common';

export type FirebaseUserNotification = {
  announcementNotificationEnabled: boolean;
  careTeamNotificationEnabled: boolean;
  communityNotificationEnabled: boolean;
};

type ArticleEventNotification = 'forArticles' | 'forEvents';

type ArticleEventResponse = {
  notificationPreference: { [key in ArticleEventNotification]: boolean };
};

const fetchArticleEventNotificationQuery = gql`
  query notificationPreference {
    notificationPreference {
      forArticles
      forEvents
    }
  }
`;

const updateArticleEventNotificationQuery = gql`
  mutation saveNotificationPreference(
    $preference: NotificationPreferenceInput
  ) {
    saveNotificationPreference(preference: $preference)
  }
`;

export const fetchArticleEventNotification = async () => {
  const { data } = await graphql.query<ArticleEventResponse>({
    query: fetchArticleEventNotificationQuery,
    fetchPolicy: 'no-cache',
  });
  return data.notificationPreference;
};

export const updateArticleEventNotification = async (
  forArticlesEnabled: boolean,
  forEventsEnabled: boolean,
) => {
  await graphql.mutate({
    mutation: updateArticleEventNotificationQuery,
    variables: {
      preference: {
        forArticles: forArticlesEnabled,
        forEvents: forEventsEnabled,
      },
    },
  });
};
